import React from "react";
import { FaExclamationTriangle } from "react-icons/fa";

function ErrorAlert({
  title = "Something went wrong",
  message = "Unable to display request",
}) {
  return (
    <div className="mt-50 assessment_not_paid mb-50">
      <FaExclamationTriangle color="red" size={25} />
      <p className="mt-10 fs-18">
        <strong>{title}</strong>
      </p>
      <span>{message}</span>
    </div>
  );
}

export default ErrorAlert;
